import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Lamp, Cookie, Box, Wand2, ArrowRight } from 'lucide-react';

const tools = [
  {
    id: 'lamp-generator',
    title: 'Generador de Pantallas de Lámparas',
    category: 'Iluminación',
    description: 'Modelador paramétrico de pantallas con encastre E27 (41.5mm), siluetas macro, texturas 3D volumétricas y modo vaso.',
    icon: Lamp,
    status: 'Activo',
    href: '/tools/lamp-generator',
    color: 'text-primary bg-primary/10 border-primary/20',
  },
  {
    id: 'cookie-cutter',
    title: 'Generador de Cortantes & Sellos',
    category: 'Cocina & Deco',
    description: 'Cortantes de galletitas con filo cónico afilado, pestaña de agarre ergonómica y sello interior con manija para desmoldar.',
    icon: Cookie,
    status: 'Activo',
    href: '/tools/cookie-cutter',
    color: 'text-amber-600 bg-amber-500/10 border-amber-500/20',
  },
  {
    id: 'box-generator',
    title: 'Generador de Cajas & Organizadores',
    category: 'Organización',
    description: 'Cajas milimétricas con esquinas redondeadas, separadores interiores configurables y tapa a presión snap-fit.',
    icon: Box,
    status: 'Activo',
    href: '/tools/box-generator',
    color: 'text-emerald-600 bg-emerald-500/10 border-emerald-500/20',
  },
  {
    id: 'lithophane',
    title: 'Generador de Litofanías',
    category: 'Personalizados',
    description: 'Transformá fotografías en piezas 3D que revelan la imagen al encender la luz, con formatos curvo, plano o cilíndrico.',
    icon: Wand2,
    status: 'Activo',
    href: '/tools/lithophane',
    color: 'text-purple-600 bg-purple-500/10 border-purple-500/20',
  },
];

export default function ToolsHubPage() {
  return (
    <div className="space-y-6 max-w-6xl mx-auto pb-12">
      {/* Header */}
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Hub de Herramientas 3D</h1>
          <Badge className="bg-primary/10 text-primary border-primary/20">Web-to-STL</Badge>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Suite de generadores paramétricos para fabricar modelos STL directos sin abrir software CAD.
        </p>
      </div>

      {/* Grid de Herramientas */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tools.map((tool) => {
          const isAvailable = tool.status === 'Activo';
          const Icon = tool.icon;

          return (
            <Card
              key={tool.id}
              className={`overflow-hidden border transition-all flex flex-col justify-between ${
                isAvailable
                  ? 'border-border/80 hover:shadow-md hover:border-primary/50'
                  : 'border-dashed border-border/60 opacity-80'
              }`}
            >
              <CardContent className="p-6 space-y-4">
                <div className="flex items-start justify-between">
                  <div className={`p-3 rounded-2xl border ${tool.color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <Badge variant={isAvailable ? 'default' : 'secondary'} className="text-xs">
                    {tool.status}
                  </Badge>
                </div>

                <div className="space-y-1">
                  <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    {tool.category}
                  </div>
                  <h3 className="text-xl font-bold tracking-tight">{tool.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed pt-1">
                    {tool.description}
                  </p>
                </div>
              </CardContent>

              <div className="p-4 bg-muted/20 border-t border-border/60 flex items-center justify-between">
                {isAvailable ? (
                  <Button asChild className="w-full gap-2">
                    <Link to={tool.href}>
                      Abrir Generador <ArrowRight className="h-4 w-4" />
                    </Link>
                  </Button>
                ) : (
                  <Button variant="outline" disabled className="w-full text-xs text-muted-foreground">
                    En fase de desarrollo
                  </Button>
                )}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
